///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.atp_documents = abcsetup.atp_documents || {};
abcsetup.atp_documents.common = abcsetup.atp_documents.common || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////

abcsetup.atp_documents.common = {
    bindFormElems: function () {
        // Authorized Trading Partner table
        $(document).on('change keyup', '.authorized_trading_partner_table input', function () {
            var blankRow = false;

            $('.authorized_trading_partner_table').each(function () {
                if ($(this).find('input').filter(function () { return $(this).val() === ''; }).length == 2) {
                    blankRow = true;
                }
            })

            if (!blankRow) {
                var row = $('.authorized_trading_partner_table:last').clone();
                row.find('input').val('').attr('required', false).attr('requiredIf', '').removeClass('invalid');

                // Apply a uid to the 2 fields and make them dependant on eachother
                var id = abcsetup.randomString();
                row.find('input.authorized_trading_partner_ein').attr('id', 'authorized_trading_partner_ein_' + id).attr('requiredIf', 'authorized_trading_partner_affiliate_names_' + id + '!=');
                row.find('input.authorized_trading_partner_affiliate_names').attr('id', 'authorized_trading_partner_affiliate_names_' + id).attr('requiredIf', 'authorized_trading_partner_ein_' + id + '!=');
                row.find('small').remove();
                $('.authorized_trading_partner_table:last').after(row);
            }
        });

        $('.authorized_trading_partner_table input').eq(0).trigger('change');
    },

    getUsersForOrgs: function() {
        abcsetup.setTitle('Authorized Trading Partner');
        abcsetup.atp_documents.common.bindFormElems();
        // abcsetup.atp_documents.common.disableExistingRequestOrgs();

        $("#app_models_a_t_p_document__org_id").on("change", function () {
            if ($(this).val()) {
                abcsetup.blockUI(true);

                axios.post('/api/atp_documents/get_users_for_orgs', { org_ids: $(this).val() })
                    .then((response) => {
                        if (response.data) {
                            var users = abcsetup.atp_documents.common.formatUsersResponse(response.data);
                            $("#app_models_a_t_p_document__invited_roles").empty();
                            $("#app_models_a_t_p_document__invited_roles").select2({
                                data: users
                            });
                        }
                        abcsetup.unblockUI();
                        $("#user-select-for-org").show();
                    })
                    .catch((error) => {
                        abcsetup.unblockUI();
                    });
            } else {
                $("#user-select-for-org").hide();
            }
        });

        return;
    },

    formatUsersResponse: function(usersArray) {
        var formattedUsers = [];
        var option = {};
        for (var i = 0; i < usersArray.data.length; i++) {
            for (var j = 0; j < usersArray.data[i].roles.length; j++) {
                if (usersArray.data[i].roles[j].name != null) {
                    option = {
                        'id': usersArray.data[i].roles[j].id,
                        'text': usersArray.data[i].name + ' (' + usersArray.data[i].roles[j].org.name + ' - ' + usersArray.data[i].roles[j].name + ')'
                    };
                } else {
                    option = {
                        'id': usersArray.data[i].roles[j].id,
                        'text': usersArray.data[i].name + ' (' + usersArray.data[i].roles[j].org.name + ')'
                    };
                }
                formattedUsers.push(option);
            }
        }

        return formattedUsers;
    },

    removeExistingRequests: function (existingOrgs) {
        var selectedOrgs = $('#app_models_a_t_p_document__org_id').val();

        for (var i = 0; i < existingOrgs.data.length; i++) {
            selectedOrgs = $.grep(selectedOrgs, function(value) {
                return value != existingOrgs.data[i].id;
              });
        }

        $('#app_models_a_t_p_document__org_id').val(selectedOrgs).trigger('change');
    },

    listExistingRequestOrgs: function(orgsArray) {
        var formattedOrgs = [];
        var orgsString = '';

        for (var i = 0; i < orgsArray.data.length; i++) {
            formattedOrgs.push(orgsArray.data[i].name);
            orgsString = formattedOrgs.join(", ");
        }

        return orgsString;
    },

    disableExistingRequestOrgs: function() {

        abcsetup.blockUI(true);

        axios.post('/api/atp_documents/check_existing_requests')
        .then((response) => {
            if (response.data) {
                for (var i = 0; i < response.data.data.length; i++) {
                    var org_name = $('#app_models_a_t_p_document__org_id option[value="' + response.data.data[i].id + '"]').text();
                    $('#app_models_a_t_p_document__org_id option[value="' + response.data.data[i].id + '"]').text(org_name + ' - ATP Request Already Sent');
                    $('#app_models_a_t_p_document__org_id option[value="' + response.data.data[i].id + '"]').attr('disabled', true);
                }
            }
            abcsetup.unblockUI();
        })
        .catch((error) => {
            abcsetup.unblockUI();
        });

    }
}